import request from "@/router/axios";

export const add = (row) => {
  return request({
    url: "/api/produce/location/insert",
    method: "post",
    data: row,
  });
};
export const update = (row) => {
  return request({
    url: "/api/produce/location/update",
    method: "post",
    data: row,
  });
};
export const getList = (params) => {
  return request({
    url: "/api/produce/location/select/page",
    method: "get",
    params,
  });
};
export const remove = (ids) => {
  return request({
    url: "/api/produce/location/delete/ids",
    method: "get",
    params: {
      ids,
    },
  });
};

/** 料场/煤棚分页 */
export const storePage = (params) => {
  return request({
    url: "/api/produce/store/select/page",
    method: "get",
    params,
  });
};

/** 库区 */
export const storeAreaListByMainId = (mainId) => {
  return request({
    url: "/api/produce/store-area/select/listByMainId",
    method: "get",
    params: { mainId },
  });
};
export const storeAreaInsert = (row) => {
  return request({
    url: "/api/produce/store-area/insert",
    method: "post",
    data: row,
  });
};
export const storeAreaUpdate = (row) => {
  return request({
    url: "/api/produce/store-area/update",
    method: "post",
    data: row,
  });
};
export const storeAreaDelete = (id) => {
  return request({
    url: "/api/produce/store-area/delete/id",
    method: "get",
    params: { id },
  });
};

/** 堆位 base_store_sub */
export const storeSubPage = (params) => {
  return request({
    url: "/api/produce/store-sub/select/page",
    method: "get",
    params,
  });
};
export const storeSubInsert = (row) => {
  return request({
    url: "/api/produce/store-sub/insert",
    method: "post",
    data: row,
  });
};
export const storeSubUpdate = (row) => {
  return request({
    url: "/api/produce/store-sub/update",
    method: "post",
    data: row,
  });
};
export const storeSubDelete = (id) => {
  return request({
    url: "/api/produce/store-sub/delete/id",
    method: "get",
    params: { id },
  });
};

/** 仅更新库存（stockVersion 乐观锁） */
export const storeSubUpdateStock = (row) => {
  return request({
    url: "/api/produce/store-sub/update/stock",
    method: "post",
    data: row,
  });
};
